import { render, staticRenderFns } from "./ApiVariable.vue?vue&type=template&id=a4750f46&scoped=true&"
import script from "./ApiVariable.vue?vue&type=script&lang=js&"
export * from "./ApiVariable.vue?vue&type=script&lang=js&"
import style0 from "./ApiVariable.vue?vue&type=style&index=0&id=a4750f46&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4750f46",
  null
  
)

export default component.exports